// Discharge summary section questionnaire constants
export enum DischargeSummaryQuestionnaireItem {
  DISCHARGE_SUMMARY = 'discharge-summary',
  DISCHARGE_SUMMARY_TYPES_OF_SERVICES = 'discharge-summary/types-of-services',
  DISCHARGE_SUMMARY_SERVICE_FREQUENCY = 'discharge-summary/service-frequency',
  DISCHARGE_SUMMARY_LAST_DATE_OF_SERVICE = 'discharge-summary/last-date-of-service',
  DISCHARGE_SUMMARY_DISCHARGE_CONDITION = 'discharge-summary/discharge-condition',
  DISCHARGE_SUMMARY_REASON_FOR_DISCHARGE = 'discharge-summary/reason-for-discharge',
  DISCHARGE_SUMMARY_LABORATORY_DATA = 'discharge-summary/laboratory-data',
  DISCHARGE_SUMMARY_PLAN_OF_CARE_OUTCOMES = 'discharge-summary/plan-of-care-outcomes',
  DISCHARGE_SUMMARY_DISCHARGE_INSTRUCTIONS = 'discharge-summary/discharge-instructions',
  DISCHARGE_SUMMARY_POST_DISCHARGE_TREATMENT = 'discharge-summary/post-discharge-treatment',
  DISCHARGE_SUMMARY_POST_DISCHARGE_GOALS = 'discharge-summary/post-discharge-goals'
}
